module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_GSE176078.3ed28c4a.png";